import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import template from './uploadButton.jsx';
import uploadStatuses from './uploadStatuses';

var UploadButton = /*#__PURE__*/function (_React$Component) {
  _inherits(UploadButton, _React$Component);

  var _super = _createSuper(UploadButton);

  function UploadButton(props) {
    var _this;

    _classCallCheck(this, UploadButton);

    _this = _super.call(this, props);

    _this.getButtonContent = function () {
      return _this.props.status === uploadStatuses.NONE ? _this.props.buttonContent.beforeUpload : _this.props.buttonContent.afterUpload;
    };

    _this.isStatusNone = function () {
      return _this.props.status === uploadStatuses.NONE;
    };

    _this.isDisabled = function () {
      return _this.props.disabled || _this.props.status === uploadStatuses.IN_PROCESS;
    };

    return _this;
  }

  _createClass(UploadButton, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return UploadButton;
}(React.Component);

UploadButton.displayName = displayNames.UPLOAD_BUTTON;
UploadButton.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,

  /** The value to be displayed when the upload status is set to UPLOAD_SUCCESS. Usually will be the name of the uploaded file */
  value: PropTypes.string,

  /** Callback function to be triggered when clicking on the button */
  onClick: PropTypes.func.isRequired,

  /** Sets the button to disable mode */
  disabled: PropTypes.bool,

  /** The text/node to be displayed inside the button. */
  buttonContent: PropTypes.shape({
    beforeUpload: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    afterUpload: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
  }),

  /** The status of the upload process */
  status: PropTypes.oneOf(['NONE', 'UPLOAD_SUCCESS', 'UPLOAD_FAILED', 'IN_PROCESS']),

  /** The error message of the upload. Leave empty in case there is no error */
  errorMessage: PropTypes.string,

  /** The message to displayed when the upload status is IN_PROCESS*/
  processMessage: PropTypes.string
};
UploadButton.defaultProps = {
  disabled: false,
  status: uploadStatuses.NONE
};
export default compose(UploadButton);